import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function LinkedTransaction({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Linked transaction type</b>
          </p>
          <p>
            Linked transaction objects represent a transaction that is linked to
            the current transaction or line.
            <pre>
              <code>
                {`
{
  “id”: integer, 
  “transactionType”: string,
  “refNumber”: string,
  “linenumber”: integer
}
`}
              </code>
            </pre>
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
LinkedTransaction.propTypes = {
  type: PropTypes.string.isRequired
};
